import { type WorkflowTemplate } from './Types'
import Product from './Statuses/Product'
import Marketing from './Statuses/Marketing'
import Basic from './Statuses/Basic'
import Exec from './Statuses/Exec'
import Sales from './Statuses/Sales'
import Default from './Statuses/Default'

export enum TemplateType {
  Basic = 'Basic',
  Product = 'Product',
  Marketing = 'Marketing',
  Exec = 'Exec',
  Sales = 'Sales',
  Default = 'Default',
  Custom = 'Custom',
}

export const templates: WorkflowTemplate[] = [
  {
    id: TemplateType.Default,
    title: () => 'Default',
    emoji: '📄',
    statuses: Default,
  },
  {
    id: TemplateType.Basic,
    title: () => 'Basic Review',
    emoji: '🏠',
    statuses: Basic,
  },
  {
    id: TemplateType.Product,
    title: () => 'Product',
    emoji: '👩‍💻',
    statuses: Product,
  },
  {
    id: TemplateType.Marketing,
    title: () => 'Marketing',
    emoji: '✏️',
    statuses: Marketing,
  },
  {
    id: TemplateType.Exec,
    title: () => 'Exec',
    emoji: '📊',
    statuses: Exec,
  },
  {
    id: TemplateType.Sales,
    title: () => 'Sales',
    emoji: '🗂',
    statuses: Sales,
  },
]
